module.exports = __webpack_public_path__ + "static/img/center-bg.a4c66efb.png";